import styled from 'styled-components';


export const Wrapper = styled.div`
    width:100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100vh;
   
`;

export const Content = styled.div`
    flex-grow:1;
    overflow-y: scroll;
    overflow-wrap: break-word;
    @media screen and (max-width: 768px){
        padding-bottom: 60px;
    }
`;


export const Title = styled.span`
    font-weight:bold;
`
export const Line = styled.div`

`

export const MLabel = styled.small`
    color: #6c757d;
`

export const Text = styled.div`
    max-height: 110px;
    width: 100%;
    overflow-y: scroll;
    border:1px solid #e6e6e6b5;
    border-radius: 8px;
    background-color: #eee;
    padding: 2px 4px;
`

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3px 10px;
    background-color:#d3e8d8;
    font-size:var(--fontSMed);
    font-weight:600;
    border-top: 3px solid var(--lightGreen);
`;